/* 🤖 this file was generated by svg-to-ts */
export const matIconPhotoSizeSelectSmall: {
  name: 'photo-size-select-small';
  data: string;
} = {
  name: 'photo-size-select-small',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"/></svg>`
};
